import { HTTPClient } from 'koajax';

export const service = new HTTPClient({
  baseURI: 'https://api.github.com/',
  responseType: 'json'
});

export const tvClient = new HTTPClient({
  baseURI: 'https://min-api.cryptocompare.com',
  responseType: 'json'
});

export interface TVData<T = any> {
  Response?: 'Error';
  Message?: string;
  Data: T;
}

export function loadImage(path: string) {
  const image = new Image();

  return new Promise<HTMLImageElement>((resolve, reject) => {
    image.onload = () => resolve(image);
    image.onerror = reject;
    image.src = path;
  });
}
